import { render, staticRenderFns } from "./SfMegaMenuColumn.vue?vue&type=template&id=0636ddb4"
import script from "./SfMegaMenuColumn.vue?vue&type=script&lang=js"
export * from "./SfMegaMenuColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "0ed7446f"
  
)

export default component.exports